export const money = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export const num = (v) => Number(v || 0).toLocaleString("it-IT");

// Durations/waits everywhere: 45 min · 11 h 25 min · 2 g 3 h (never thousands of minutes)
export function fmtMin(v) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const m = Math.max(0, Math.floor(Number(v)));
  if (m < 60) return `${m} min`;
  if (m < 1440) return `${Math.floor(m / 60)} h${m % 60 ? ` ${m % 60} min` : ""}`;
  const h = Math.floor((m % 1440) / 60);
  return `${Math.floor(m / 1440)} g${h ? ` ${h} h` : ""}`;
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtTime = (d) => (d ? new Date(d).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "");

const TZ = "Europe/Rome";
const dayKey = (d) => new Date(d).toLocaleDateString("sv-SE", { timeZone: TZ });
const dayDiff = (d) => Math.round((new Date(dayKey(new Date())) - new Date(dayKey(d))) / 86400000);
// Message time: today 23:44 · ieri 23:44 · 5 ott 23:44 (full date on hover)
export function fmtMsgTime(d) {
  if (!d) return "";
  const t = new Date(d).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: TZ });
  const n = dayDiff(d);
  if (n === 0) return t;
  if (n === 1) return `ieri ${t}`;
  return `${new Date(d).toLocaleDateString("it-IT", { day: "numeric", month: "short", timeZone: TZ, ...(new Date(d).getFullYear() !== new Date().getFullYear() ? { year: "numeric" } : {}) })} ${t}`;
}
export const fmtFull = (d) => (d ? new Date(d).toLocaleString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: TZ }) : "");
// Day separator like Telegram: Oggi · Ieri · Lunedì 5 ottobre · 4 ottobre 2025
export function fmtDay(d) {
  const n = dayDiff(d);
  if (n === 0) return "Oggi";
  if (n === 1) return "Ieri";
  const old = new Date(d).getFullYear() !== new Date().getFullYear();
  const s = new Date(d).toLocaleDateString("it-IT", old ? { day: "numeric", month: "long", year: "numeric", timeZone: TZ } : { weekday: "long", day: "numeric", month: "long", timeZone: TZ });
  return s.charAt(0).toUpperCase() + s.slice(1);
}
export const sameDay = (a, b) => a && b && dayKey(a) === dayKey(b);
// Chat list: time if today, 'Ieri', otherwise '5 ott'
export function fmtListTime(d) {
  if (!d) return "";
  const n = dayDiff(d);
  if (n === 0) return new Date(d).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: TZ });
  if (n === 1) return "Ieri";
  return new Date(d).toLocaleDateString("it-IT", { day: "numeric", month: "short", timeZone: TZ });
}

export function ago(d) {
  if (!d) return "—";
  const s = (Date.now() - new Date(d).getTime()) / 1000;
  if (s < 60) return "ora";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)}g`;
  return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short" });
}

export const initials = (n = "") => (n || "").replace("@", "").split(/[\s._]+/).map((x) => Array.from(x).find((ch) => /\p{L}|\p{N}/u.test(ch))).filter(Boolean).slice(0, 2).map((x) => x.toUpperCase()).join("") || "?";

const PALETTE = ["#7C3AED", "#3B82F6", "#10B981", "#F59E0B", "#EC4899", "#06B6D4", "#EF4444", "#8B5CF6"];
export const colorFor = (s = "") => PALETTE[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % PALETTE.length];

export const fill = (tpl, vars) => tpl.replace(/\{(\w+)\}/g, (m, k) => vars[k] ?? m);

export const ROLE_LABEL = { owner: "Titolare", manager: "Manager", chatter: "Chatter", viewer: "Solo visualizzazione", marketing: "Marketing" };
export const isStaff = (u) => ["owner", "admin", "manager", "viewer"].includes(u?.role);
export const isAdmin = (u) => ["owner", "admin", "viewer"].includes(u?.role);
export const isViewer = (u) => u?.role === "viewer";
export const chartAxis = { stroke: "#64748B", fontSize: 11, tickLine: false, axisLine: false };
export const CHART = ["#7C3AED", "#3B82F6", "#10B981", "#F59E0B", "#EC4899"];
export const shortDay = (t, gran = "day") => {
  const d = new Date(t);
  if (gran === "hour") return d.toLocaleTimeString("it-IT", { hour: "2-digit" });
  if (gran === "month") return d.toLocaleDateString("it-IT", { month: "short", year: "2-digit" });
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short" });
};
